import { Button } from '@shared/components/ui/button';
import { faPlus } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

interface CreateBankAccountButtonProps {
  onClick: () => void;
}

export const CreateBankAccountButton = ({ onClick }: CreateBankAccountButtonProps) => {
  const { t } = useTranslation('bankAccountsModule');

  return (
    <Button variant="primary" size="default" onClick={onClick} data-testid="create-bank-account-button">
      <FontAwesomeIcon icon={faPlus} className="w-4 h-4 mr-2" />
      {t('buttons.create')}
    </Button>
  );
};
